import { jsxs as l, jsx as e } from "react/jsx-runtime";
import { useTranslation as o } from "react-i18next";
import { BearGif as t } from "../../../../../components/elements/bear-loader/bear-loader.js";
import a from "./list-loader-and-help-text.module.less.js";
const c = ({ text: r }) => /* @__PURE__ */ l("div", { className: a.loaderWrapper, children: [
  r && /* @__PURE__ */ e("p", { className: "mt-0 mb-2xs", children: r }),
  /* @__PURE__ */ e("img", { className: a.loaderImage, src: t })
] }), I = ({ isListingStations: r, isLoadingGeolocation: s }) => {
  const { t: m } = o();
  return /* @__PURE__ */ l("div", { className: a.wrapper, children: [
    s && !r && /* @__PURE__ */ e(c, { text: m("FIND_STATION_LOADING_POSITION_LABEL") }),
    !s && !r && /* @__PURE__ */ e("p", { className: "body-base mb-0", children: m("FIND_STATION_LIST_AVAILABLE_ACTIONS_TEXT") })
  ] });
};
export {
  I as default
};
